
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import styles from './ContactPage.module.css';
import MobiStyles from './ContactPageMobi.module.css';

import SwiperSection from '../ForAllComponents/SwiperSection';
import ConnUrls from '../Connections/ConnectURL';
import { MobiOrNotContext } from '../Contexts/MobiOrNot_Context';
import utilsContactPage from '../Connections/_Utils/utilsContactPage';
import MyFunctions from '../Functions/MyFunctions';
import { CurrentPContext } from '../Contexts/CurrentP_Context';

const ContactPage = (props) => {
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [currnetStyle, setCurrentStyle] = useState(!mobiOrNot ? styles : MobiStyles);
    const [pageDetails, setPageDetails] = useState()


    const [fullName, setFullName] = useState("")
    const [phoneNum, setPhoneNum] = useState("")
    const [email, setEmail] = useState("")
    const [txtAre, setTxtAre] = useState("")
    const [erMsg, setErMsg] = useState("")


    useEffect(() => {
        setCurrentStyle(!mobiOrNot ? styles : MobiStyles)
    }, [mobiOrNot]);

    useEffect(() => {
        const getPageDetalis = async () => {
            let pg = await utilsContactPage.getContactPageById(props.pageID);
            setPageDetails(pg);
            setCurrentPage({ ...pg, pageTYp: "" });
        }
        getPageDetalis();
    }, [])


    const sendMsg = async () => {
        let validatoring = "";

        validatoring = (fullName != "" && fullName.length > 2) ? "" : "<p>יש להזין שם מלא</p>";
        validatoring += MyFunctions.validPhone(phoneNum);
        validatoring += MyFunctions.validEmail(email);
        validatoring += (txtAre != "") ? "" : "<p>יש להזין תוכן הודעה</p>";
        if (validatoring == "") {

            let msgg = {
                fullName, phoneNum, email, txtAre, subj: "הודעה באתר"
            }
            let sndMsg = await utilsContactPage.sendMsg(msgg);
            // console.log(sndMsg)
            setErMsg(sndMsg.msg)
            setFullName("");
            setPhoneNum("");
            setEmail("");
            setTxtAre("");
        }
        else {
            setErMsg(validatoring)
        }
    }






    return (
        <div className={`${currnetStyle.MainMenuPage} regularPoint `}>
            {pageDetails &&
                <>
                    {(pageDetails.openingImage || pageDetails.openingImageMobi) ?
                        <div className={currnetStyle.TopWrap}>
                            <div className={currnetStyle.TopImg}
                                style={{
                                    backgroundImage:
                                        `url("${ConnUrls.servMediasUrl}${!mobiOrNot || !pageDetails.openingImageMobi ?
                                            pageDetails.openingImage : pageDetails.openingImageMobi}")`
                                }}>
                                {!pageDetails.withOutOpenintxt &&
                                    <div className={currnetStyle.TopTxtBlock}>

                                        <div className={`${currnetStyle.InBlockTxt} animate__animated animate__zoomInDown regularPoint`}>
                                            <div className={`${currnetStyle.theTxt}`}>
                                                {parse(`${pageDetails.openingContent}`)}
                                            </div>
                                        </div>

                                    </div>
                                }

                            </div>
                        </div>
                        :
                        <>
                            {!pageDetails.withOutOpenintxt &&
                                <div className={currnetStyle.TopNoImg}>
                                    <div className={currnetStyle.TopTxtBlock}>

                                        <div className={`${currnetStyle.InBlockTxt} animate__animated animate__zoomInDown regularPoint`}>
                                            <div className={`${currnetStyle.theTxt}`}>
                                                {parse(`${pageDetails.openingContent}`)}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }


                        </>
                    }
                    {pageDetails.mainTitle && pageDetails.mainTitle !== "" &&
                        <>
                            <h1 className={currnetStyle.mainTextHead}>
                                {pageDetails.mainTitle}
                            </h1>


                            <div className={`${currnetStyle.footerInSocials} centerByMargin`}>
                                <div className={"tblcell"}>

                                    <div className={`${currnetStyle.socialIcon} spaceMargeRight_10`}>
                                        <img src={`${ConnUrls.PermanentImages}/smalLogoicon.png`} alt="נפוליאון" />
                                    </div>
                                </div>
                                <div className={"tblcell"}>

                                    <div className={`${currnetStyle.socialIcon} spaceMargeRight_10`}>
                                        <img src={`${ConnUrls.PermanentImages}/smalLogoicon.png`} alt="נפוליאון" />
                                    </div>
                                </div>
                                <div className={"tblcell"}>

                                    <div className={`${currnetStyle.socialIcon} spaceMargeRight_10`}>
                                        <img src={`${ConnUrls.PermanentImages}/smalLogoicon.png`} alt="נפוליאון" />
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {pageDetails.whatssup && pageDetails.whatssup !== "" &&
                        <div className={`${currnetStyle.whatssUpGo} pointing`}>
                            <a href={` https://wa.me/+${parse(pageDetails.whatssup)}`} target='_blank'>
                                למענה מהיר ונציג אישי בWatssUp <br />לחץ כאן
                            </a>
                        </div>
                    }

                    {pageDetails.addressLine && pageDetails.addressLine !== "" &&
                        <div className={currnetStyle.lnkTxt}>
                            כתובתינו: {parse(`${pageDetails.addressLine}`)}
                        </div>
                    }

                    {pageDetails.emailContact && pageDetails.emailContact !== "" &&
                        <div className={currnetStyle.lnkTxt}>
                            אימייל: <a href={`mailto:${parse(pageDetails.emailContact)}`} target='_blank'>
                                {parse(`${pageDetails.emailContact}`)}</a>
                        </div>
                    }

                    {pageDetails.phoneNum && pageDetails.phoneNum !== "" &&
                        <div className={currnetStyle.lnkTxt}>
                            טלפון: <a href={`tel:${parse(pageDetails.phoneNum)}`} target='_blank'>
                                {parse(`${pageDetails.phoneNum}`)}</a>
                        </div>
                    }



                    {pageDetails.mainContent &&
                        pageDetails.mainContent.replace('<p>', '').replace('</p>', '').replace('<br>', '') !== "" &&
                        <div className={currnetStyle.mainText}>
                            {parse(`${pageDetails.mainContent}`)}
                        </div>
                    }

                    {pageDetails.emailContact && pageDetails.emailContact !== "" &&

                        <>

                            <div className={currnetStyle.ContactsData}>
                                <div className={currnetStyle.contWrap}>
                                    {/* <label className={`${currnetStyle.headInput}`}>שם מלא</label> */}
                                    <input
                                        className={`${currnetStyle.GoSendData} ${erMsg.includes("שם מלא") ? "errorInput" : ""}`}
                                        placeHolder={"שם מלא"} value={fullName}
                                        onChange={(e) => setFullName(e.target.value)} label="שם מלא" variant="filled" />
                                </div>
                                <div className={currnetStyle.contWrap}>
                                    {/* <label className={`${currnetStyle.headInput}`}>טלפון</label> */}
                                    <input
                                        className={`${currnetStyle.GoSendData} ${erMsg.includes("טלפון") ? "errorInput" : ""}`}
                                        placeHolder={"טלפון"} value={phoneNum} onChange={(e) =>
                                            setPhoneNum(e.target.value)} label="טלפון" variant="filled" />
                                </div>
                                <div className={currnetStyle.contWrap}>
                                    {/* <label className={`${currnetStyle.headInput}`}>מייל</label> */}
                                    <input
                                        className={`${currnetStyle.GoSendData} ${erMsg.includes("מייל") ? "errorInput" : ""}`}
                                        placeHolder={"מייל"} value={email} onChange={(e) =>
                                            setEmail(e.target.value)} label="מייל" variant="filled" />
                                </div>
                                <div className={currnetStyle.contWrap}>

                                    {/* <label className={`${currnetStyle.headInput} fullRow`}>תוכן ההודעה</label> */}
                                    <textarea
                                        className={`${currnetStyle.GoSendData} ${erMsg.includes("תוכן הודעה") ? "errorInput" : ""}`}

                                        placeHolder={"תוכן ההודעה"} rows={4} value={txtAre} onChange={(e) =>
                                            setTxtAre(e.target.value)} label="טקסט חופשי" variant="filled" ></textarea>
                                </div>
                                <div className={currnetStyle.contWrap}>
                                    <div className={currnetStyle.GoSendData}>
                                        <div className={currnetStyle.btnGo}>
                                            <button className={`${currnetStyle.contactGo} pointing`} value="שלח" onClick={() => sendMsg()} >שלח</button>
                                        </div>
                                        <div className={"fullRow errorLine bold"}>
                                            <p className={"centerText"}>{erMsg !== "" ? "יש למלא את כל הפרטים המסומנים" : ""}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>

                    }



                </>
            }
        </div >


    );
}

export default ContactPage;
